



























import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import MainTabbar from "../general/MainTabbar.vue";

import GroupsOverview from "./GroupsOverview.vue";
import GroupsOffers from "./GroupsOffers.vue";
import GroupsBookings from "./GroupsBookings.vue";
import GroupsCalendar from "./GroupsCalendar.vue";
import GroupsAll from "./GroupsAll.vue";
import GroupsMyBookings from "./GroupsMyBookings.vue";
import GroupsPayments from "./GroupsPayments.vue";
import GroupsPrograms from "./GroupsPrograms.vue";

import SettingsJson from "../../shared/SettingsJson";
import SettingsNotificationsJson from "../../shared/SettingsNotificationsJson";
import UserJson from "../../shared/UserJson";
import ModulesJson, { checkModuleIsActivated } from "../../shared/ModulesJson";
import { checkPermission } from "../../shared/UserPermission";
import { UserPermissionType } from "../../shared/UserPermissionType";

export default Vue.extend({
  name: "Groups",
  components: {
    MainTabbar,
    GroupsOverview,
    GroupsOffers,
    GroupsBookings,
    GroupsCalendar,
    GroupsAll,
    GroupsMyBookings,
    GroupsPayments,
    GroupsPrograms,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    settingsNotifications: Object as PropType<SettingsNotificationsJson>,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      currentMainTabbarTab: "",
      checkModuleIsActivated: checkModuleIsActivated,
      checkPermission: checkPermission,
      GroupsBookingStatusNames: {
        requested: "Angefragt, Angebot ausstehend",
        offerToCustomer: "Angebot erstellt, warten auf Kunde",
        offerAccepted: "Angebot vom Kunden angenommen",
        booked: "Angenommen und gebucht",
        readyForPayment: "Bereit für Bezahlung",
        paymentExported: "Rechnung wurde exportiert",
        cancellationPending: "Abgesagt, Bestätigung benötigt",
        canceled: "Abgesagt, Gebühr-Export ausstehend",
        cancellationFeeExported: "Abgesagt, Gebühr wurde exportiert",
      },
    };
  },
  created() {},
  methods: {
    changeMainTabbarTab: function (tab: string) {
      this.currentMainTabbarTab = tab;
    },
  },
  computed: {
    mainTabbarItems(): ModulesJson[] {
      let vue = this;

      return [
        {
          title: "Übersicht",
          linkedComponent: "GroupsOverview",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleGroups),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleGroups),
        },
        {
          title: "Angebote",
          linkedComponent: "GroupsOffers",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleGroups),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleGroups),
        },
        {
          title: "Buchungen",
          linkedComponent: "GroupsBookings",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleGroups),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleGroups),
        },
        {
          title: "Kalender",
          linkedComponent: "GroupsCalendar",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleGroups),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleGroups),
        },
        {
          title: "Alle",
          linkedComponent: "GroupsAll",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleGroups),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleGroups),
        },
        {
          title: "Meine Zuständigkeiten",
          linkedComponent: "GroupsMyBookings",
          permissionRank: 1,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 1, UserPermissionType.moduleGroups),
          isDisplayed: vue.checkPermission(vue.loginUser, 1, UserPermissionType.moduleGroups),
        },
        {
          title: "Zahlungen",
          linkedComponent: "GroupsPayments",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.modulePayments),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.modulePayments),
        },
        {
          title: "Angebote für Gruppen",
          linkedComponent: "GroupsPrograms",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleGroups),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleGroups),
        },
      ] as ModulesJson[];
    },
  },
});
